import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { ThemedCssCreator } from "../../../config/emotion";

type GetIconCss = (
  isActive: boolean,
  forceDangerColor?: boolean
) => ThemedCssCreator;

export const getIconCss: GetIconCss =
  (isActive, forceDangerColor) =>
  ({ colors }) =>
    css`
      padding-bottom: 0;
      padding-top: 0;
      font-size: 24px;
      color: ${(() => {
        if (forceDangerColor) return colors.delete;
        if (isActive) return colors.primaryColor;
        return "#c0c6d0";
      })()};
    `;

type GetNavItemCss = (isActive: boolean) => ThemedCssCreator;
export const getNavItemCss: GetNavItemCss =
  (isActive) =>
  ({ colors }) =>
    css`
      width: 100%;
      position: relative;
      min-height: 3.5rem;
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
      list-style: none;
      border-top: 1px solid rgb(231, 232, 236);

      &:last-of-type {
        border-bottom: 1px solid rgb(231, 232, 236);
      }

      box-shadow: ${isActive ? `0 2px 0 ${colors.primaryColor}` : ""};
    `;

type GetNavLinkCss = (isActive: boolean) => ThemedCssCreator;
export const getNavLinkCss: GetNavLinkCss =
  (isActive) =>
  ({ colors }) =>
    css`
      color: ${isActive
        ? colors.primaryColor
        : "rgb(192, 198, 208)"} !important; // přebití bootstrapu

      background-color: transparent;
      &:hover {
        color: ${colors.primaryColor} !important;
      }
    `;

export const navbarCss = css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 99999;
  height: 3.8rem;
  padding: 0 1rem 0 1.5rem;
  width: 100vw;
  background-color: #fff;

  border-bottom: 1px solid #dee2e6 !important;

  @media only screen and (min-width: 1025px) {
    padding: 0;
    height: 4.5rem;
    flex-direction: row;
    flex-wrap: nowrap;
  }
`;

export const CollapseContainer = styled("ul", {
  shouldForwardProp: (prop) => prop !== "visible",
})<{ visible: boolean }>`
  position: absolute;
  top: 3.5rem;
  left: 0;
  height: calc(100vh - 3.5rem);
  width: 100%;
  background-color: #fff;
  overflow-y: auto;

  padding: 0;
  margin: 0;

  display: flex;
  transform: ${({ visible }) =>
    visible ? "translateX(0)" : "translateX(-100%)"};
  transition: 500ms ${({ visible }) => (visible ? "ease-out" : "ease-in")};
  flex-direction: column;
`;

export const RightSectionContainer = styled.ul`
  position: absolute;
  right: 1rem;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;

  gap: 1.5rem;
`;

export const Header = styled.header`
  position: fixed;
  z-index: 1049;
  width: 100%;
  top: 0;
  background: #fff;
`;
